import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 16px;
  overflow: auto;
  background: ${({ theme }) => theme.contentBackground};
`;

export const HeaderCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  color: #1f2937;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #4b5563;
  line-height: 1.5;
`;

export const InfoGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

export const InfoCard = styled.article`
  padding: 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const InfoLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const InfoValue = styled.div`
  margin-top: 8px;
  font-size: 16px;
  color: #111827;
  word-break: break-word;
`;

export const SelectionCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const SelectionField = styled.select`
  width: 100%;
  max-width: 360px;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #ffffff;
  color: #111827;
  font-size: 14px;
  outline: none;
`;

export const SelectionHint = styled.div`
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px dashed #cbd5e1;
  background: #f8fafc;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
`;

export const ActionBar = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const ExecutionModeGroup = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
`;

export const ExecutionModeButton = styled.button`
  border: 0;
  border-radius: 8px;
  padding: 8px 12px;
  background: ${({ active }) => (active ? "#2563eb" : "transparent")};
  color: ${({ active }) => (active ? "#ffffff" : "#374151")};
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const ProgressCluster = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-left: auto;
`;

export const ProgressCard = styled.div`
  min-width: 150px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
`;

export const BatchSizeField = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
`;

export const BatchSizeSelect = styled.select`
  min-width: 96px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff;
  color: #111827;
  font-size: 13px;
  outline: none;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const DateTimeInput = styled.input`
  min-width: 220px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff;
  color: #111827;
  font-size: 13px;
  outline: none;
`;

export const ColumnsCard = styled.section`
  padding: 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const SectionTitle = styled.h2`
  margin: 0 0 12px;
  font-size: 18px;
  color: #111827;
`;

export const BadgeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Badge = styled.span`
  padding: 6px 10px;
  border-radius: 999px;
  background: ${({ tone }) => (tone === "danger" ? "#fee2e2" : "#e5f0ff")};
  color: ${({ tone }) => (tone === "danger" ? "#b91c1c" : "#1d4ed8")};
  font-size: 13px;
  font-weight: 600;
`;

export const TableCard = styled.section`
  padding: 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const TableHeaderBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
`;

export const TableHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TableActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`;

export const HelperText = styled.p`
  margin: 0 0 12px;
  color: #6b7280;
  font-size: 13px;
  line-height: 1.4;
`;

export const ProgressBarSection = styled.section`
  padding: 16px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const ProgressHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
`;

export const ProgressPercent = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 12px;
  border-radius: 999px;
  overflow: hidden;
  background: #e5e7eb;
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: ${({ value }) => value}%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2563eb 0%, #10b981 100%);
  transition: width 0.2s ease;
`;

export const TableWrap = styled.div`
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    text-align: left;
    font-size: 13px;
    vertical-align: top;
  }

  th {
    background: #f8fafc;
    color: #1f2937;
    font-weight: 700;
  }

  td:last-child {
    white-space: normal;
    min-width: ${({ wideLastColumn }) => (wideLastColumn ? "380px" : "auto")};
    line-height: 1.45;
  }
`;

export const LogTypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  background: ${({ tone }) =>
    tone === "error" ? "#fee2e2" : tone === "warning" ? "#fff7ed" : "#eff6ff"};
  color: ${({ tone }) =>
    tone === "error" ? "#b91c1c" : tone === "warning" ? "#9a3412" : "#1d4ed8"};
`;

export const SummaryGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
`;

export const SummaryCard = styled.article`
  padding: 14px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const SummaryValue = styled.div`
  margin-top: 8px;
  font-size: 24px;
  font-weight: 700;
  color: #111827;
`;

export const EmptyState = styled.div`
  padding: 24px;
  border-radius: 12px;
  background: #ffffff;
  text-align: center;
  color: #6b7280;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
`;

export const ModalText = styled.p`
  margin: 0 0 12px;
  color: #334155;
  line-height: 1.5;
`;

export const SelectionAlertContent = styled.div`
  display: block;
`;

export const WarningList = styled.div`
  display: block;
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
`;

export const WarningItem = styled.div`
  padding: 12px;
  border-radius: 10px;
  background: ${({ tone }) => (tone === "danger" ? "#fef2f2" : "#fff7ed")};
  border: 1px solid ${({ tone }) => (tone === "danger" ? "#fca5a5" : "#fdba74")};
`;

export const WarningTitle = styled.div`
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  color: ${({ tone }) => (tone === "danger" ? "#b91c1c" : "#9a3412")};
`;

export const WarningBody = styled.div`
  font-size: 13px;
  color: ${({ tone }) => (tone === "danger" ? "#991b1b" : "#7c2d12")};
  line-height: 1.5;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
  padding-bottom: 4px;
  background: #ffffff;
`;

export const StatusBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
  padding: 14px 16px;
  border-radius: 12px;
  background: ${({ tone }) =>
    tone === "success" ? "#ecfdf5" : tone === "danger" ? "#fef2f2" : "#eff6ff"};
  border: 1px solid
    ${({ tone }) => (tone === "success" ? "#86efac" : tone === "danger" ? "#fca5a5" : "#93c5fd")};
`;

export const StatusTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ tone }) =>
    tone === "success" ? "#166534" : tone === "danger" ? "#b91c1c" : "#1d4ed8"};
`;

export const StatusText = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ tone }) =>
    tone === "success" ? "#166534" : tone === "danger" ? "#991b1b" : "#1e40af"};
`;

export const StatusMeta = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ tone }) =>
    tone === "success" ? "#15803d" : tone === "danger" ? "#b91c1c" : "#2563eb"};
`;

export const StatusActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
`;
